import React, {  useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../../utils/localStorage";
import AdminMenu from "../../../AdminMenu";
import StoreMenu from "../../../StoreMenu";
import ButtonLink from "../../../../ButtonLink";

const CardData = [
  {
    id: 1,
    name: "Bulk Out For Delivery",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/My_Profile.png",
    backgroundColor: "#AD39BF",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/BulkOutForDelivery",
    bulkProcessingType: "Out_For_Delivery",
  },
  {
    id: 2,
    name: "Bulk Home Delivery",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/discount.png",
    backgroundColor: "#E63F52",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/BulkProcessing",
    bulkProcessingType: "Home_Delivery",
  },
  {
    id: 3,
    name: "Bulk Mark Ready",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/price-tag.png",
    backgroundColor: "#F5C621",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/BulkProcessing",
    bulkProcessingType: "Mark_Ready",
  },
  {
    id: 4,
    name: "Bulk Payment",
    icon: "Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif",
    backgroundColor: "#1F78D9",
    tintColor: null,
    navigation: "/BulkProcessing",
    bulkProcessingType: "Payment",
  },
];

const AdminData = [
  {
    id: 1,
    name: "Bulk Home Delivery",
    icon: "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/My_Profile.png",
    backgroundColor: "#AD39BF",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/BulkProcessing",
    bulkProcessingType: "Home_Delivery",
  },
  {
    id: 2,
    name: "Bulk Payment",
    icon: "Laundy_App_Icons_Gifs/SettingIcons/discount.png",
    backgroundColor: "#E63F52",
    tintColor: "invert(100%) sepia(100%) saturate(500%) hue-rotate(200deg)",
    navigation: "/BulkProcessing",
    bulkProcessingType: "Payment",
  },
];

const BulkProcessingList = () => {
  const navigate = useNavigate();

  const [visible, setVisible] = useState(false);

  const { userProfileRole } = getUserData();
  const userRole = userProfileRole;

  const renderCardItem = () => {
    return CardData?.map((item, index) => {
      if (userRole === "BY_RIDER" && item.name === "Store User") {
        return null;
      }
      return (
        <div
          onClick={() => navigate(item.navigation, {
            state: item.bulkProcessingType
          })}
          className="flex flex-1 cursor-pointer"
        >
          <div
            className="p-3 m-2"
            style={{
              backgroundColor: item.backgroundColor,
              borderRadius: 10,
            }}
          >
            <img
              src={item.icon}
              style={{
                height: 25,
                width: 25,
                filter: item.tintColor,
              }}
              alt=""
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div>
              <p className="text-3xl font-semibold">{item.name}</p>
            </div>
            <div>
              <i
                className="pi pi-angle-right"
                style={{ fontSize: "30px", cursor: "pointer", color: "#000" }}
              ></i>
            </div>
          </div>
        </div>
      );
    });
  };

  const renderAdminCardItem = () => {
    return AdminData?.map((item, index) => {
      if (userRole === "BY_RIDER" && item.name === "Store User") {
        return null;
      }
      return (
        <div
          onClick={() => navigate(item.navigation, {
            state: item.bulkProcessingType
          })}
          className="flex flex-1 cursor-pointer"
        >
          <div
            className="p-3 m-2"
            style={{
              backgroundColor: item.backgroundColor,
              borderRadius: 10,
            }}
          >
            <img
              src={item.icon}
              style={{
                height: 25,
                width: 25,
                filter: item.tintColor,
              }}
              alt=""
            />
          </div>
          <div className="ml-4 flex flex-1 justify-content-between  align-items-center">
            <div>
              <p className="text-3xl font-semibold">{item.name}</p>
            </div>
            <div>
              <i
                className="pi pi-angle-right"
                style={{ fontSize: "30px", cursor: "pointer", color: "#000" }}
              ></i>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Bulk Processing
              </p>
            </div>
          </div>

          {userRole !== "BY_WAREHOUSE" && (
            <div
              className="flex justify-content-center align-items-center cursor-pointer"
              onClick={() => setVisible(true)}
            >
              <i
                className="pi pi-bars"
                style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
              ></i>
            </div>
          )}
        </div>
      </div>

      <div className="mx-4 my-3">
        {userRole === "BY_ADMIN" ||
        userRole === "BY_SUB_ADMIN_USER" ||
        userRole === "BY_FRANCHISE_ADMIN" ? (
          AdminData?.length ? (
            renderAdminCardItem()
          ) : (
            <div className="flex justify-content-center my-4">
              <p className="text-2xl font-semi-bold">
                No admin data available.
              </p>
            </div>
          )
        ) : userRole === "BY_STORE" && CardData?.length ? (
          renderCardItem()
        ) : (
          <div className="flex justify-content-center my-4">
            <p className="text-2xl font-semi-bold">No data available.</p>
          </div>
        )}

        <div className="flex justify-content-center">
          <img
            src={"VectorsLaundryApp/4.png"}
            style={{
              // width: 100,
              // height: 50,
              alignSelf: "center",
            }}
            alt=""
          />
        </div>
        {/* <StoreLanguage
          setModalLangVisible={setModalLangVisible}
          modalLangVisible={modalLangVisible}
        /> */}
      </div>
      {userRole === "BY_ADMIN" ||
      userRole === "BY_SUB_ADMIN_USER" ||
      userRole === "BY_FRANCHISE_ADMIN" ? (
        <AdminMenu setVisible={setVisible} visible={visible} />
      ) : (
        <>
          <StoreMenu setVisible={setVisible} visible={visible} />
          <ButtonLink />
        </>
      )}
    </div>
  );
};

export default BulkProcessingList;
